import React, { useContext, useEffect, useState } from "react";
import css from "../css/Refer.module.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import { BsWhatsapp } from "react-icons/bs";
import { BsChevronDown } from "react-icons/bs";
import { BsPerson } from "react-icons/bs";
import { BsCash } from "react-icons/bs";

import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
import CopyToClipboard from "react-copy-to-clipboard";
import { FaTelegramPlane } from "react-icons/fa";
import { FiCopy } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);
  const theme = localStorage.getItem("theme");

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const [cardData, setGame] = useState([]);

  const copyCode = (e) => {
    navigator.clipboard.writeText(user.referral_code);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const copyLink = (e) => {
    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referal Link Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  if (user === undefined) {
    return null;
  }

  const referralText = `Hi Friends, Play khelstar Ludo and earn 10000 daily. Download Indian App khelstar
  बम्मफर  धमाका ऑफर  💸💸💸 💥💥💥💥💥💥
   दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा
  
    NK ADDA पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
    100% भरोसेमंद प्लेटफार्म । 24 hours support https://khelstar.com/login/${user.referral_code}
    
    Your ReferralCode is -${user.referral_code}.`;

  // language

  const translations = {
    hi: {
      referral: "आपकी रेफरल कमाई",
      referPerson: "आमंत्रित किये दोस्त | ",
      referEarn: "रेफरल कमाई  ",
      referCode: "रेफरल कोड ",
    },
    en: {
      referral: "Your Referral Earnings",
      referPerson: "Referred Players",
      referEarn: "Referral Earning",
      referCode: "Referral Code",
    },
  };

  // change theme

  const styles = {
    backgroundColor: theme === "light" ? "#FFFFF0" : "black",
    color: theme === "light" ? "black" : "black",
  };
  const styles1 = {
    color: theme === "light" ? "black" : "white",
  };

  return (
    <>
      {/* <Header user={user} /> */}
      <div style={styles}>
        <div
          className="leftContainer"
          style={{ ...styles, minHeight: "100vh", height: "100%" }}
        >
          <section className="refer_page_main_section">
            {/* --- Header Section --- */}
            <div className="page_heading_div text-center mb-4">
              <h2 className="section-title">Refer & Earn</h2>
              <p className="section-subtitle">
                Invite your friends and earn real money together.
              </p>
            </div>

            {/* --- 1. Referral Code Section (Coupon Style) --- */}
            <div className="mb-5">
              <div className="refer-coupon-card">
                <div className="refer-header">
                  <h2 className="profile_headings card-label">
                    {translations[language].referCode}
                  </h2>
                </div>

                <div className="code-area-wrapper">
                  <div className="code-box">
                    <span className="code-text">{user.referral_code}</span>
                  </div>
                  <button
                    className="copy-action-btn"
                    onClick={(e) => copyCode(e)}
                  >
                    Copy Code
                  </button>
                </div>

                <p className="small-helper-text">
                  Tap the button to copy & share
                </p>
                     <div className="whatsapp_share_btn">
                  <a
                    // href={`whatsapp://send?text=Hi%20Friends%2C%20Play%20khelstar%20Ludo%20and%20earn%2010000%20daily.%20Download%20Indian%20App%20khelstar%20%0A%E0%A4%AC%E0%A4%AE%E0%A5%8D%E0%A4%AE%E0%A4%AB%E0%A4%B0%20%E0%A4%A7%E0%A4%AE%E0%A4%BE%E0%A4%95%E0%A4%BE%20%E0%A4%91%E0%A4%AB%E0%A4%B0%20%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%E0%A5%8B%E0%A4%82%20%E0%A4%86%20%E0%A4%97%E0%A4%AF%E0%A4%BE%20%E0%A4%B9%E0%A5%88%20%E0%A4%AD%E0%A4%BE%E0%A4%B0%E0%A4%A4%20%E0%A4%95%E0%A4%BE%20%E0%A4%AA%E0%A4%B9%E0%A4%B2%E0%A4%BE%20%E0%A4%90%E0%A4%B8%E0%A4%BE%20%E0%A4%97%E0%A5%87%E0%A4%AE%E0%A4%BF%E0%A4%82%E0%A4%97%20%E0%A4%AA%E0%A5%8D%E0%A4%B2%E0%A5%87%E0%A4%9F%E0%A4%AB%E0%A5%89%E0%A4%B0%E0%A5%8D%E0%A4%AE%20%E0%A4%9C%E0%A4%B9%E0%A4%BE%20%E0%A4%86%E0%A4%AA%E0%A4%95%E0%A5%8B%20win%20%E0%A4%AA%E0%A4%B0%20%E0%A4%B0%E0%A5%88%E0%A4%AB%E0%A4%B0%20%E0%A4%95%E0%A4%AE%E0%A5%80%E0%A4%B6%E0%A4%A8%205%25%20%E0%A4%A6%E0%A4%BF%E0%A4%AF%E0%A4%BE%20%E0%A4%9C%E0%A4%BE%E0%A4%8F%E0%A4%97%E0%A4%BE%20%E0%A4%85%E0%A4%97%E0%A4%B0%20%E0%A4%86%E0%A4%AA%E0%A4%95%E0%A4%BE%20%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%20%E0%A4%86%E0%A4%AA%E0%A4%95%E0%A5%87%20%E0%A4%B0%E0%A5%87%E0%A4%AB%E0%A4%B0%20%E0%A4%B8%E0%A5%87%20%E0%A4%97%E0%A5%87%E0%A4%AE%20%E0%A4%96%E0%A5%87%E0%A4%B2%E0%A4%A4%E0%A4%BE%20%E0%A4%A4%E0%A5%8B%20%E0%A4%86%E0%A4%AA%E0%A4%95%E0%A5%8B%203%25%20commission%20%E0%A4%A6%E0%A4%BF%E0%A4%AF%E0%A4%BE%20%E0%A4%9C%E0%A4%BE%E0%A4%AF%E0%A5%87%E0%A4%97%E0%A4%BE%0A%E0%A4%94%E0%A4%B0%20%E0%A4%A4%E0%A5%81%E0%A4%B0%E0%A4%82%E0%A4%A4%20%E0%A4%85%E0%A4%AA%E0%A4%A8%E0%A5%87%20Bank%20%E0%A4%AF%E0%A4%BE%20UPI%20%E0%A4%AE%E0%A5%87%E0%A4%82%20%E0%A4%9F%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%82%E0%A4%B8%E0%A4%AB%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%B8%E0%A4%95%E0%A4%A4%E0%A5%87%20%E0%A4%B9%E0%A5%8B%20%0A100%25%20%E0%A4%AD%E0%A4%B0%E0%A5%8B%E0%A4%B8%E0%A5%87%E0%A4%AE%E0%A4%82%E0%A4%A6%20%E0%A4%AA%E0%A5%8D%E0%A4%B2%E0%A5%87%E0%A4%9F%E0%A4%AB%E0%A4%BE%E0%A4%B0%E0%A5%8D%E0%A4%AE%20%E0%A5%A4%2024%20hours%20support%20https%3A%2F%2Fkhelstar.com%2Flogin%2F${user.referral_code}%0A`}
                    href={`whatsapp://send?text=Play%20On%20khel%20star%20%0A%E0%A4%B2%E0%A5%82%E0%A4%A1%E0%A5%8B%20%E0%A4%96%E0%A5%87%E0%A4%B2%20%E0%A4%95%E0%A4%B0%20%E0%A4%AF%E0%A4%BE%20%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%E0%A5%8B%E0%A4%82%20%E0%A4%95%E0%A5%8B%20%E0%A4%B6%E0%A5%87%E0%A4%AF%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%95%E0%A5%87%20%E0%A4%AA%E0%A5%88%E0%A4%B8%E0%A4%BE%20%E0%A4%9C%E0%A5%80%E0%A4%A4%E0%A5%8B%20%E0%A4%94%E0%A4%B0%20%E0%A4%A4%E0%A5%81%E0%A4%B0%E0%A4%82%E0%A4%A4%20%E0%A4%85%E0%A4%AA%E0%A4%A8%E0%A5%87%20Bank%20%E0%A4%AF%E0%A4%BE%20UPI%20%E0%A4%AE%E0%A5%87%E0%A4%82%20%E0%A4%9F%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%82%E0%A4%B8%E0%A4%AB%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%B8%E0%A4%95%E0%A4%A4%E0%A5%87%20%E0%A4%B9%E0%A5%88%E0%A5%A4%0A%0AAuto%20Deposit%20%26%20Auto%20Withdrawal%0A%0AInstant%20Withdrawal%20Via%20UPI%2FBank%2FWallet%20%0A%0ACommission%205%25%20Only%0AReferral%20commission%203%25%0A%0A100%25%20%E0%A4%AD%E0%A4%B0%E0%A5%8B%E0%A4%B8%E0%A5%87%E0%A4%AE%E0%A4%82%E0%A4%A6%20%E0%A4%AA%E0%A5%8D%E0%A4%B2%E0%A5%87%E0%A4%9F%E0%A4%AB%E0%A4%BE%E0%A4%B0%E0%A5%8D%E0%A4%AE%20%0A%0A24x7%20Live%20Chat%20%26%20Call%20Support%0A%0Ahttps%3A%2F%2Fkhelstar.com%2Flogin%2F${user.referral_code}`}
                  >
                    <BsWhatsapp className="icons" />
                    <span class="ml-2">Whatsapp</span>
                  </a>
                </div>
              </div>
            </div>

            {/* --- 2. Statistics Section (Dashboard Cards) --- */}
            <div className="refer-stats-container">
              <div className="stats-header mb-3">
                <h3 className="profile_headings">
                  {translations[language].referral}
                </h3>
              </div>

              <div className="stats-grid">
                {/* Card: Total Referred Users */}
                <div className="stat-card">
                  <div className="stat-icon-box bg-blue-light">
                    <BsPerson className="stat-icon text-blue" />
                  </div>
                  <div className="stat-info">
                    <span className="stat-label">
                      {translations[language].referPerson}
                    </span>
                    <h4 className="stat-value">
                      {user.referral_user?.length
                        ? user.referral_user.length
                        : 0}
                    </h4>
                  </div>
                </div>

                {/* Card: Total Earnings */}
                <div className="stat-card">
                  <div className="stat-icon-box bg-green-light">
                    <BsCash className="stat-icon text-green" />
                  </div>
                  <div className="stat-info">
                    <span className="stat-label">
                      {translations[language].referEarn}
                    </span>
                    <h4 className="stat-value text-green">
                      ₹{user.referral_earning ? user.referral_earning : 0}
                    </h4>
                  </div>
                </div>
              </div>
            </div>

             {/* <div style={{ width: "fit-content", marginBottom: "10px" }}>
              <a
                href="https://youtu.be/X0m4MeTRwK4?si=6rsjvpUfNxMs8yUN"
                target="_blank"
              >
                <span
                  className="d-flex align-items-center  btn-md guide_btn"
                  style={{
                    right: "0.5rem",
                    backgroundColor: "#003441",
                    color: "white",
                    borderRadius: "4px",
                    padding: "4px 13px",
                    fontSize: "12px",
                  }}
                >
                  Youtube
                  <img
                    className="ml-2"
                    src={"/images/Homepage/youtube.png"}
                    alt=""
                    width="15px"
                  />
                </span>
              </a>
            </div> */}

            {/* <div className="refer_page_top_main_box_outer mt-5">
              <div className="refer_page_top_main_box">
                <h2 className="profile_headings">How It Works</h2>
              </div>
              <div className="refer_page_top_main_box_inner">
                <div className="refer_rules">
                  <p>
                    1. You can refer and Earn Win 3% and Loss 1% of your
                    referral winning, every time
                  </p>
                  <p>
                    2. Like if your player plays for khelstar Coin. 10000 and
                    wins, You will get khelstar Coin. 300 as referral amount.
                  </p>
                </div>
              </div>
            </div> */}
          </section>
        </div>
      </div>
    </>
  );
};

export default Refer;
